import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import InstructorSidebar from '../components/instructor/InstructorSidebar';
import Logo from '../components/layout/Logo';

export default function InstructorLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className="flex h-screen bg-canvas-50 overflow-hidden">
      <InstructorSidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
      />

      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-brand-950/40 z-30 md:hidden"
          onClick={() => setIsMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <div
        className={`flex-1 flex flex-col min-w-0 overflow-y-auto transition-all duration-300 ${
          isCollapsed ? 'md:ml-20' : 'md:ml-64'
        }`}
      >
        <div className="md:hidden sticky top-0 z-20 bg-white border-b border-canvas-300 px-4 py-3 flex items-center gap-3">
          <button
            onClick={() => setIsMobileOpen(true)}
            className="p-2 -ml-2 text-brand-900 hover:bg-canvas-100 rounded-lg transition-colors"
            aria-label="Open menu"
          >
            <FontAwesomeIcon icon={faBars} className="h-5 w-5" />
          </button>
          <Logo size="sm" asLink={false} />
        </div>

        <Outlet />
      </div>
    </div>
  );
}
